import React from "react";
import { Badge } from "reactstrap";
//Icons
import EditIcon from "react-icons/lib/md/edit";
import ToolTipItem from "../utils/tooltip";
import { Table, Th, Thead, Tr, Td } from "reactable";

class AirportTable extends React.Component {
  render() {
    let { data, editCallback } = this.props;
    return (
      <div>
        <Table
          className="table table-striped table-hover"
          id="table"
          sortable={true}
          itemsPerPage={15}
          pageButtonLimit={10}
        >
          <Thead>
            <Th column="Name">
              <span>Name</span>
            </Th>
            <Th column="Code">
              <span>Airport Code</span>
            </Th>
            <Th column="CountryCode">
              <span>Country Code</span>
            </Th>
            <Th column="Type">
              <span>Airport Type</span>
            </Th>
            <Th column="IsRegional">
              <span>Is Regional</span>
            </Th>
            <Th column="Action">Action</Th>
          </Thead>

          {data.map((item, i) => (
            <Tr key={i}>
              <Td column="Name" className="text-capitalize">
                {item.Name}
              </Td>
              <Td column="Code">{item.Code}</Td>
              <Td column="CountryCode" className="text-capitalize">
                {item.CountryCode}
              </Td>
              <Td
                column="Type"
                className="text-capitalize"
                value={item.IsLocal}
              >
                <span>
                  {item.IsLocal && (
                    <Badge color="warning">&nbsp;Local&nbsp;</Badge>
                  )}
                  {!item.IsLocal && (
                    <Badge color="success">
                      &nbsp;&nbsp;International&nbsp;&nbsp;
                    </Badge>
                  )}
                </span>
              </Td>
              <Td
                column="IsRegional"
                className="text-capitalize"
                value={item.IsRegional}
              >
                <Badge color={item.IsRegional ? "success" : "danger"}>
                  &nbsp;&nbsp;{item.IsRegional ? "Yes" : "No"}&nbsp;&nbsp;
                </Badge>
              </Td>
              <Td column="Action">
                <span
                  className="text-primary pointer"
                  onClick={(e) => editCallback(item)}
                >
                  <ToolTipItem
                    key={i + "edit"}
                    title={<EditIcon size="15" color="#43a8df" />}
                    content="Edit record"
                    id={i + "edit"}
                  />
                </span>
              </Td>
            </Tr>
          ))}
        </Table>
      </div>
    );
  }
}
export default AirportTable;



// WEBPACK FOOTER //
// ./src/views/airport/airport-table.js